import {addToWishlist} from "../../library/wishlist";
import {ecSendData, trackEvent, trackLinkEvent} from "../../library/analytics";
import {productClick, viewProducts} from "../../website/webpack/modules/algolia-insights";
import {onVisible} from "../../website/scripts/Tools/visible-element-observer";
import {itemDatalayerPush} from "../../website/webpack/modules/analytics";
import {getLastViewedProducts} from "../../website/webpack/modules/last-viewed-products";

let relatedLegacySliderPromise = null;

function loadRelatedLegacySlider()
{
    if ($.fn.initializeSlider) {
        return Promise.resolve();
    }
    if (!relatedLegacySliderPromise) {
        relatedLegacySliderPromise = import("../carousel/related-products-legacy-slider");
    }
    return relatedLegacySliderPromise;
}

export function initRelatedProductsSlider(container, threshold, callback)
{
    return loadRelatedLegacySlider().then(function() {
        $(container).initializeSlider(threshold, callback);
    });
}

// For markup rendered elsewhere (e.g. the cart): native markup only comes from the home, which loads its initialiser
export function initRelatedCarousel(container, threshold)
{
    if (container.find('.related-carousel').length) {
        if (typeof window.initWebHomeRelatedProductsCarousel === 'function') {
            window.initWebHomeRelatedProductsCarousel(container.get(0));
        }
        return Promise.resolve();
    }
    return initRelatedProductsSlider(container, threshold);
}

$(document).ready(function() {
    //sendAlgoliaProductView();

    $(document).on('click', '.related-container .list-product', function(e){
        e.stopPropagation();
        let id = $(this).find('input[name="id"]').val();
        productClick('Related', 'Click Product', id);
        let link = $(this).find('a');
        let name = link.text();
        let listName = $('#listName').length ? $('#listName').val() + ' - ' : 'Product Page - ';
        let refCode = $(this).find('input[name="reference"]').val();
        let parent = $(this).parents('.related-container').first();
        let type = parent.data('type') ? parent.data('type') : '';
        let list = listName + 'Related Products - ' + type;
        ecSendData(refCode, name, null, null, null, null, null, 'click', {list: list});
        trackLinkEvent('Related', 'click', name, link, e);
    });

    $(document).on('click', '.search-related-container .list-product', function(e){
        e.stopPropagation();
        let link = $(this).find('a');
        trackLinkEvent('SearchRelated', 'click', link.text(), link, e);
    });

    $(document).on('click', '.related-container .wishlist', function(e){
        e.stopPropagation();
        let form = $(this).find('.wishlist-icon-form');
        addToWishlist(form);
        trackEvent('Related', 'WishList', $(this).siblings('title').text());
    });

    $(document).on('click', '.related-container .related-nav', function() {
        trackEvent('Related', 'ShowMoreProducts', '');
    })

    $(document).on('click', '.search-related-container .related-nav', function() {
        trackEvent('SearchRelated', 'ShowMoreProducts', '');
    })

    bestSellersContent = '';
    loadRelatedProducts();

    onVisible(document.querySelectorAll(".last-viewed-products-container"), function (element) {
        initializeLastViewProducts();
    });
});

let algoliaProductsViewed = [];
function sendAlgoliaProductView()
{
    let ids = [];
    $('.related-container .list-product').each(function() {
        let product = $(this);
        let id = product.find('input[name="id"]').val();
        if (!algoliaProductsViewed.includes(id)) {
            algoliaProductsViewed.push(id);
            ids.push(id);

            if (ids.length == 20) {
                viewProducts('Related', 'View Product', ids);
                ids = [];
            }
        }
    });

    if (ids.length) {
        viewProducts('Related', 'View Product', ids);
    }
}

export var bestSellersContent = '';
export function loadRelatedProducts($container) {
    /*if (!window.showRelatedProducts) {
        return;
    }*/
    let emptyContainer = (typeof $container === 'undefined');
    $container = $container || $('body');
    $container.find('.related-container, .search-related-container').each(function() {
        let container = $(this);
        if (emptyContainer && container.hasClass('search-related-container')) {
            return;
        }
        let type = container.data('type') || null;
        let excluded = container.data('excluded') || null;
        let categoryName = container.data('categoryname') || null;
        let productType = container.data('producttype') || null;
        let categories = container.data('categories') || null;
        let appVersion = container.data('appversion') || null;
        if (type && container.is(':empty')) {
            $.post(
                '/ajax/related-products/load',
                {
                    type: type,
                    pathname: location.pathname,
                    excluded: excluded,
                    categoryName: categoryName,
                    productType: productType,
                    categories: categories,
                    appVersion: appVersion,
                },
                function(data) {
                    if (data.relatedProducts) {
                        if (data.relatedProducts.multiContainer) {
                            for (var key in data.relatedProducts.multiContainer) {
                                let initialize = true;
                                if (data.relatedProducts.multiContainer.hasOwnProperty(key)) {
                                    if (container.hasClass('search-related-container')) {
                                        if (key === 'search-best-sellers' || key === 'search-similar-products') {
                                            bestSellersContent = data.relatedProducts.multiContainer[key] || '';
                                        }
                                        container = $('.search-related-container[data-content="' + key + '"]');
                                    } else {
                                        if (type === 'home' && key === 'best-sellers' &&
                                            !data.relatedProducts.multiContainer['best-sellers']) {
                                            initialize = false;
                                        }

                                        if (key === 'best-sellers' || key === 'similar-products') {
                                            bestSellersContent = data.relatedProducts.multiContainer[key] || '';
                                        }
                                        container = $('.related-container[data-content="' + key + '"]');
                                    }

                                    if (initialize) {
                                        fillRelatedContainer(container, data.relatedProducts.multiContainer[key]);
                                    }
                                }
                            }
                        } else {
                            fillRelatedContainer(container, data.relatedProducts);
                        }
                        //sendAlgoliaProductView();
                        onVisible(document.querySelectorAll(".fire-product-datalayer"), (element) => itemDatalayerPush('view_item_list', element));
                    }
                }
            );
        }
    });
}

function fillRelatedContainer(container, html)
{
    if (!html) {
        return;
    }
    container.html(html);
    if (shouldInitNativeHomeRelated(container)) {
        if (typeof window.initWebHomeRelatedProductsCarousel === 'function') {
            window.initWebHomeRelatedProductsCarousel(container.get(0));
        }
        return;
    }
    initRelatedProductsSlider(container, 20);
}

function shouldInitNativeHomeRelated(container)
{
    if (container.data('type') !== 'home') {
        return false;
    }
    if (container.data('carouselEngine') === 'native') {
        return true;
    }
    return container.find('.related-carousel').length > 0;
}

export function initializeLastViewProducts() {
    $('.last-viewed-products-container').each(function() {
        let container = $(this);
        // Only the home block is built for the native carousel; the carts, 404, etc. keep Swiper
        let native = container.data('carouselEngine') === 'native'
            && typeof window.initWebHomeRelatedProductsCarousel === 'function';
        $.post(
            '/ajax/website/product-list/get-last-viewed-products-recommender',
            {
                oldView: true,
                lastViewedProducts: getLastViewedProducts(),
                engine: native ? '' : 'legacy'
            },
            function(data) {
                if (data.recommender) {
                    container.html(data.recommender);
                    container.removeClass('last-viewed-products-container');
                    if (native) {
                        window.initWebHomeRelatedProductsCarousel(container.get(0));
                        return;
                    }
                    initRelatedProductsSlider(container, 20);
                } else {
                    container.remove();
                }
            }
        );
    });
}

